/**
 * All entities schemas must be registered here
 */
import { schema } from 'normalizr'

export const user = new schema.Entity('users', {}, { idAttribute: 'docId' })
export const users = new schema.Array(user)
export const organization = new schema.Entity('organizations', {}, { idAttribute: 'docId' })
export const organizations = new schema.Array(organization)
